import { render, staticRenderFns } from "./EcommerceSellerProductTable.vue?vue&type=template&id=4856d487&scoped=true&"
import script from "./EcommerceSellerProductTable.vue?vue&type=script&lang=js&"
export * from "./EcommerceSellerProductTable.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceSellerProductTable.vue?vue&type=style&index=0&id=4856d487&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4856d487",
  null
  
)

export default component.exports